import 'magnific-popup/dist/magnific-popup.css';

import './nav-tabs-cmg';
import './home-page';
import './brand-home-page';
import './careers';
import './find-loan/search-loan';
import './loan';
import './loan-tabs';
import './search-blog';
import './grant';
import './calculator/calculator-init';
import './correspondentcontact';
import './ourstory';
import './lo-bar';
import './corporateapplynow';
import './team';
import './partners';
import './true-partners';
import './common';
import './testimonial-video';
import './inputmask';
import './my-site-tab';
import './video-landing-page';
import './embedcode';
import './jvrecruiting-homepage';
import './recruiting-navigation';
import './rate-rebound';
import './list-n-lock';
import './list-n-lock_confirmation-page';
import './list-n-lock_floatdown-page';
import './list-n-lock_landing-page';
import './list-n-lock_purchase-page';
import './list-n-lock-stripe';
import './recruiting-vip-video';
import './communityone';
import './spec-lock/spec-lock';
import './spec-lock/speclock-purchase';
import './spec-lock/speclock-confirmation';
import './builder-forward/confirmation-page';
import './builder-carousel';
import './partner-appraiser';

import $ from 'jquery';
import PageManager from './pageManager';

import SiteNavigator from './siteNavigator';

$(function () {
    new SiteNavigator();
    new PageManager();
});
